<template>
  <div class="vehicleActivity">
    <ul>
      <li v-for="(item,index) in sendData" :key="'i_'+index"
          :class="[{'ToBeCarOwnerGui':(item.TemplateCode=='ToBeCarOwnerGuide' && queryId=='UserCenter_Top')},{'onecItem': sendData.length==1}]"
          :item="JSON.stringify(item)"
          @click="openPage(JSON.stringify(item))">
        <img :src="item.LinkUrl">
      </li>
    </ul>
  </div>
</template>

<script>
import { orderSource, resourceUrl } from '@/utils/env';
export default {
  name: 'productTip',
  data () {
    return {
      resourceUrl: resourceUrl
    }
  },
  props: {
    queryId: { default: '' },
    sendData: { default: null }
  },
  created () {
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {

    },
    openPage (e) {
      if( typeof e == 'object' ){ return; }
      let item = null;
      if( typeof e == 'string' ){ item = JSON.parse(e) }
      let openType = '';
      if( item.LandingPage.indexOf('https://')!=-1 || item.LandingPage.indexOf('http://')!=-1 ){
        openType = 'html'
      } else {
        openType = 'app'
      }
      if( orderSource==16 ){
        dfpanda.openPage(JSON.stringify({type: openType, url: item.LandingPage}))
      } else if( orderSource==17 ) {
        window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: openType, url: item.LandingPage}));
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.vehicleActivity {
  width: 100%;
  ul {
    width: 100%;
    .onecItem {
      margin-top: 0;
    }
    li {
      width: 100%;
      margin: 20px auto 0;
      img { width: 100%; }
    }
    .ToBeCarOwnerGui {
      background-color: #FB8E21;
      margin-top: 0 !important;
      padding-top: 15px;
      width: 100%;
      height: 145px;
      overflow: hidden;box-sizing: border-box;
      img { vertical-align: bottom;  }
    }
  }
}
</style>

